import { MDBAlert, MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit';
import React, { forwardRef, useState } from 'react'
import { useNavigate } from 'react-router';
import { deleteSMSBrand } from '../../../../apiclients/streamsapi_bridge';
import { useTranslation } from 'react-i18next';
import PopupLoader from '../../PopupLoader';

const DeleteSMSBrand = forwardRef((props, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [showWarning, setShowWarning] = useState(false);
    const warningToggle = () => setShowWarning(!showWarning);
    const [Warningalert, setWarningalert] = useState("");
    async function removeThisBrand(e, flag = 0) {
        try {
            e?.preventDefault();
            e?.stopPropagation();
            setInternalError(false);
            props.setIsloading(true);
            let deleteGrpReponse = await deleteSMSBrand(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.brandId, flag);
            setTimeout(() => { props.setIsloading(false) }, 1000);
            let delInfo = await deleteGrpReponse.json();

            if (delInfo.status == 'success') {
                localStorage.setItem("s_message", delInfo.message);
                props.onClose();

                window.location.href = "/smslanding";

            } else {
                if (delInfo.warning_msg) {
                    setWarningalert(delInfo.warning_msg);
                    setShowWarning(true);

                } else {
                    localStorage.setItem("f_message", delInfo.message);
                    window.location.href = "/smslanding";
                }

            }
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }

    const handleOk = (e) => {
        removeThisBrand(e, 1);
    }

    return (

        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{t("RemoveSMSBrandtxt")}</span>
            </div>
            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisBrand(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeThisBrand(e)}>
                    {t("add")}</button>
            </div>

            {showWarning && (
                <>
                    <PopupLoader
                        title="Alert"
                        content={
                            <>
                                <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                                    <MDBIcon
                                        fas
                                        icon="exclamation-triangle"
                                        className="me-3 fs-5 mt-1"
                                        color="warning"
                                    />
                                    <div>{Warningalert}</div>
                                </div>
                                <MDBModalFooter>
                                    <MDBBtn color="secondary" onClick={(e) => { warningToggle(); props.onClose(); }}>Cancel</MDBBtn>
                                    <MDBBtn
                                        onClick={(e) => {
                                            warningToggle();
                                            handleOk(e);
                                        }}
                                    >
                                        {t("OK")}
                                    </MDBBtn>
                                </MDBModalFooter>
                            </>
                        }
                        onShow={setShowWarning}
                        onClose={warningToggle}
                    />
                </>
            )}

        </>


    )
});

export default DeleteSMSBrand
